import { IS_UAT } from "@/config"

export const routes = [
  {
    path: "/",
    name: "public-layout",
    children: [
      {
        path: "/get-a-quote",
        name: "get-a-quote",
        beforeEnter: () => {
          // Redirect to partners site, this page has been deprecated on Gaia
          const partnersUrl = IS_UAT ? "https://partners.uat.vitablehealth.com" : "https://partners.vitablehealth.com"
          window.location.href = partnersUrl
        }
      }
    ]
  }
]
